<script setup lang="ts">
import { computed, ref } from 'vue';

import { useElementEmptiness } from '#composables/useElementEmptiness';
import { useLanguage } from '#composables/useLanguage';

const props = defineProps<{
  title?: string;
  columns?: number;
  class?: string;
}>();

const { t } = useLanguage();

const elementRef = ref<HTMLElement | null>(null);
const hideMetricRow = useElementEmptiness(elementRef);

const classes = computed(() => ({
  'grid-cols-2': !props.columns || props.columns === 2,
  'grid-cols-1': props.columns === 1,
  'grid-cols-3': props.columns === 3,
  'grid-cols-4': props.columns === 4,
  'grid-cols-5': props.columns === 5,
  'grid-cols-6': props.columns === 6,
  ...(props.class ? { [props.class]: true } : {})
}));
</script>

<template>
  <div v-if="!hideMetricRow" class="w-full flex flex-col">
    <h3 v-if="title" class="font-bold text-2xl mb-6" v-text="t(title)" />
    <div ref="elementRef" :class="classes" class="grid">
      <slot />
    </div>
  </div>
</template>
